import React, { useState } from 'react';
import Navbar from '../Navbar/Navbar';
import { Outlet, useLocation } from 'react-router-dom';
import Footer from '../Footer/Footer';
import DashBoardLayout from '../DashBoardLayout/DashBoardLayout';

const Layout = () => {
  const location = useLocation();
  const [isDashboard, setIsDashboard] = useState(false);


  React.useEffect(() => {
    setIsDashboard(location.pathname.startsWith('/dashboard'));

  }, [location.pathname]);

  return (
    <>
      {isDashboard ? (
        <DashBoardLayout />
      ) : (
        <>
          <Navbar />
          <Outlet />
          <Footer />
        </>
      )}
    </>
  );
};

export default Layout;
